import React, {FC} from "react";
import {t} from "i18next";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { changeDeliveryOptions } from "../../stateReducers/deliverySlice";

export const BuildingDetails: FC = () => {
    const deliveryOptions = useAppSelector((state) => { return state.delivery; });
    const d = useAppDispatch();

    const buildings = ['house', 'sport', 'school', 'company', 'other'];
    return (
        <React.Fragment>
            <div className="mb-3 xl:w-full">
                <label htmlFor="building"
                       className="form-label inline-block mb-2 text-gray-700">{t('delivery.building')}
                    <span
                        className="text-red-500 font-bold text-2xl">*</span>
                </label>
                <select value={deliveryOptions.building ? deliveryOptions.building : buildings[0]}
                        id="building"
                        className="form-select appearance-none
                              block
                              w-full
                              px-3
                              py-1.5
                              text-base
                              font-normal
                              text-gray-700
                              bg-white bg-clip-padding bg-no-repeat
                              border border-solid border-orange-200
                              rounded
                              m-0
                              focus:text-gray-700
                              focus:bg-white
                              focus:border-orange-200
                              focus:shadow-none
                              focus:outline-none"
                        onChange={(e) => {
                            d(changeDeliveryOptions({building: e.target.value}));
                        }}>
                    {buildings.map((item, index) => {
                        return <option key={index}
                                       value={item}>{t('delivery.buildingName.' + item)}</option>
                    })}
                </select>
            </div>
            {deliveryOptions.building !== 'house' && <div className="mb-3 xl:w-full">
                <label htmlFor="buildingDetails"
                       className="form-label inline-block mb-2 text-gray-700">{t('delivery.buildingDetails',{building:t('delivery.buildingName.' + deliveryOptions.building) })}
                    <span
                        className="text-red-500 font-bold text-2xl">*</span>
                    </label>
                <input
                    type="text"
                    className="
                                form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding
                                border border-solid border-gray-300 rounded m-0
                                focus:shadow-none
                                focus:text-gray-700 focus:bg-white focus:border-amber-400 focus:outline-none
                              "
                    value={deliveryOptions.buildingDetails}
                    onChange={(e) => d(changeDeliveryOptions({buildingDetails: e.target.value}))}
                    id="buildingDetails"
                />

            </div>
            }
        </React.Fragment>

    );
}